import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_franquia/franquia-indef-compra-recebida";

export const Route = createFileRoute("/_authenticated/franquia-indef-compra-recebida")({
  head: () => ({
    meta: [
      { title: "Compra recebida — Milky Moo Palmares" },
      {
        name: "description",
        content: "Registre compras recebidas e entrada de insumos no depósito.",
      },
      { property: "og:title", content: "Compra recebida — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Registre compras recebidas e entrada de insumos no depósito.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
